import { render, staticRenderFns } from "./ScPlug.vue?vue&type=template&id=5a14546f"
import script from "./ScPlug.vue?vue&type=script&lang=js"
export * from "./ScPlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports